import PropTypes from 'prop-types';
import React from 'react';

import Icon from '@component/icon';

const MobileSubnav = ({ children }) => (
  <div className="nav__subitems-container">
    <Icon type="Pointer" />
    <ul className="nav__subitems">{[...children]}</ul>
  </div>
);

MobileSubnav.propTypes = {
  children: PropTypes.array,
};

export default MobileSubnav;
